export const KARACHI_TIME_ZONE = 'Asia/Karachi';

export function dateFromValue(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function karachiDateKey(value = new Date()) {
  const date = dateFromValue(value) || new Date();
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: KARACHI_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(date);
  const byType = Object.fromEntries(parts.map(part => [part.type, part.value]));
  return `${byType.year}-${byType.month}-${byType.day}`;
}

export function dateInputValue(value = new Date()) {
  return karachiDateKey(value);
}

export function displayDate(value) {
  const date = dateFromValue(value);
  return date ? date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '-';
}
